import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2'

export default class UserDetail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <React.Fragment>
            <h1 className="text-center">Hi, </h1>
            <Container fluid = {true}>
                <Row>
                    <Col xs="3"></Col>
                    <Col xs="6">
                        <Form>
                        </Form>
                    </Col>
                    <Col xs="3"></Col>
                </Row>
            </Container>
            </React.Fragment>

        );
    }
}
